import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import axios from "axios";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const formReportServices = {
  addUpdateReportStudyMetadata,
  getReportStudyMetadataData,
  uploadReportLogo,
  findReportStudyMetadataData,
  findProtocolMetadataData,
  getAssignedVisitFormForReport,
  getVisitFormForReport,
  getFormForReport
};

//  Upload Logo
async function uploadReportLogo(formData) {
  const response = await axios.post(
    `${config.API_URL_USER_ONBOARDING}uploadReportLogo`,
    formData
  );
  const data = response?.data;
  handleResponse(data);
  return data;
}

async function addUpdateReportStudyMetadata(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdateReportStudyMetadata`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function getReportStudyMetadataData() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getReportStudyMetadataData`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function findReportStudyMetadataData(type) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}findReportStudyMetadataData/${type}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function findProtocolMetadataData(studyId, parameterName) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}findProtocolMetadataData/${studyId}/${parameterName}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getAssignedVisitFormForReport(studyId, studyUniqueId, studyMode, dataType) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAssignedVisitFormForReport/${studyId}/${studyUniqueId}/${studyMode}/${dataType}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getVisitFormForReport(studyId, dataType) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getVisitFormForReport/${studyId}/${dataType}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getFormForReport(studyId, formUniqueId, dataType) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getFormForReport/${studyId}/${formUniqueId}/${dataType}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}